import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MaskService } from '@shared/services/mask.service';

import { AliquotaIbsEditDialogData } from './aliquota-ibs-edit-dialog-data';
import { AliquotaIbsEditDialogResult } from './aliquota-ibs-edit-dialog-result';

export { AliquotaIbsEditDialogData } from './aliquota-ibs-edit-dialog-data';
export { AliquotaIbsEditDialogResult } from './aliquota-ibs-edit-dialog-result';

/** Modal simples de edição do valor de uma alíquota IBS. Retorna o novo valor; a persistência é feita pelo chamador. */
@Component({
    selector: 'app-aliquota-ibs-edit-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        NgxCurrencyDirective,
    ],
    templateUrl: './aliquota-ibs-edit-dialog.component.html',
    styleUrl: './aliquota-ibs-edit-dialog.component.css',
})
export class AliquotaIbsEditDialogComponent {
    public valor: number;

    /** 4 casas decimais para preservar a precisão do campo anterior (step 0,0001). */
    public readonly percentMask4 = this.maskService.getPercentMask(4);

    constructor(
        private dialogRef: MatDialogRef<AliquotaIbsEditDialogComponent, AliquotaIbsEditDialogResult>,
        @Inject(MAT_DIALOG_DATA) public data: AliquotaIbsEditDialogData,
        private maskService: MaskService,
    ) {
        this.valor = data.pAliquota;
    }

    public get invalido(): boolean {
        return this.valor === null || this.valor === undefined || (this.valor as unknown as string) === '' || this.valor < 0 || this.valor > 100;
    }

    public fechar(): void {
        this.dialogRef.close();
    }

    public salvar(): void {
        if (this.invalido) return;
        this.dialogRef.close({ pAliquota: this.valor });
    }
}
